import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownGender, EmptyString, FormTypeAdd, FormTypeEdit, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import { ApiDeleteRoomType, ApiGetRoomType, ApiInsertRoomType, ApiUpdateRoomType } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment"
import { GetStatus, money } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"

export default function RoomTypeForm(){
    const navigate = useNavigate()

    const { fetch: insertRoomType } = useFetch(ApiInsertRoomType)
    const { fetch: updateRoomType } = useFetch(ApiUpdateRoomType)
    const { fetch: deleteRoomType } = useFetch(ApiDeleteRoomType)
    const { fetch: getRoomType } = useFetch(ApiGetRoomType)

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramRoomTypeId = queryString.get("roomTypeId")

    const [roomTypeName, setRoomTypeName] = useState(EmptyString)
    const [dailyPrice, setDailyPrice] = useState(EmptyString)
    const [weeklyPrice, setWeeklyPrice] = useState(EmptyString)
    const [monthlyPrice, setMonthlyPrice] = useState(EmptyString)
    const [yearlyPrice, setYearlyPrice] = useState(EmptyString)

    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)
    
    const [errorTenantName, setErrorTenantName] = useState(false)
    const [errorIdNumber, setErrorIdNumber] = useState(false)
    const [errorPlaceOfBirth, setErrorPlaceofBirth] = useState(false)
    const [errorDateOfBirth, setErrorDateOfBirth] = useState(false)
    const [errorAddress, setErrorAddress] = useState(false)
    const [errorCity, setErrorCity] = useState(false)
    const [errorProvince, setErrorProvince] = useState(false)
    const [errorCountry, setErrorCountry] = useState(false)
    const [errorPhone, setErrorPhone] = useState(false)
    const [errorGender, setErrorGender] = useState(false)
    
    const roomTypeNameChange = (e) => { setRoomTypeName(e.target.value.toUpperCase()) }
    const dailyPriceChange = (e) => { setDailyPrice(money(e.target.value)) }
    const weeklyPriceChange = (e) => { setWeeklyPrice(money(e.target.value)) }
    const monthlyPriceChange = (e) => { setMonthlyPrice(money(e.target.value)) }
    const yearlyPriceChange = (e) => { setYearlyPrice(money(e.target.value)) }
    
    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    useEffect(() => {
        if (formType ===  FormTypeEdit){
            setLoading({isOpen: true})

            fGetRoomType().then(() => {
                setLoading({isOpen: false})
            })
        }
    }, [])

    // Function Api Call
    async function fInsertRoomType(){
        await insertRoomType({
            data:{
                roomTypeName: roomTypeName.trim(),
                priceDaily: dailyPrice.replaceAll(",", ""),
                priceWeekly: weeklyPrice.replaceAll(",", ""),
                priceMonthly: monthlyPrice.replaceAll(",", ""),
                priceYearly: yearlyPrice.replaceAll(",", "")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/setting/room-type") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fUpdateRoomType(){
        await updateRoomType({
            data:{
                roomTypeId: paramRoomTypeId,
                roomTypeName: roomTypeName.trim(),
                priceDaily: dailyPrice.replaceAll(",", ""),
                priceWeekly: weeklyPrice.replaceAll(",", ""),
                priceMonthly: monthlyPrice.replaceAll(",", ""),
                priceYearly: yearlyPrice.replaceAll(",", "")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/setting/room-type") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fDeleteRoomType(){
        await deleteRoomType({
            data:{
                roomTypeId: paramRoomTypeId,
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ isOpen: true, data: { onSuccess: async () => { navigate("/setting/room-type") }} })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetRoomType(){
        await getRoomType({
            data: {
                roomTypeId: paramRoomTypeId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                let data = response.data
                
                setRoomTypeName(data.roomTypeName)
                setDailyPrice(money(data.priceDaily))
                setWeeklyPrice(money(data.priceWeekly))
                setMonthlyPrice(money(data.priceMonthly))
                setYearlyPrice(money(data.priceYearly))
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    const saveBtnClick = () => {
        if (validateForm()){
            setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
                setConfirmationModal({ isOpen: false })
                setLoading({isOpen: true})

                if (formType === FormTypeAdd){
                    fInsertRoomType().then(() => {
                        setLoading({isOpen: false})
                    })
                }else{
                    fUpdateRoomType().then(() => {
                        setLoading({isOpen: false})
                    })
                }
            }}})
        }
    }
    const deleteBtnClick = () => {
        setConfirmationModal({ isOpen: true, data: { onSuccess: async () => { 
            setConfirmationModal({ isOpen: false })
            setLoading({isOpen: true})

            fDeleteRoomType().then(() => {
                setLoading({isOpen: false})
            })
        }}})
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    function validateForm(){
        let errorCount = 0

        // if (tenantName === EmptyString){
        //     errorCount++
        //     setErrorTenantName(true)
        // }else{
        //     setErrorTenantName(false)
        // }

        

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }

    return (
        <div className="flex flex-col gap-2">
            <div>
                <div className="flex justify-between">
                    <span className="font-semibold text-2xl">Room Type Detail</span>
                </div>
            </div>
            <hr />

            <div className="mt-5 flex flex-col gap-3">
                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Room Type</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={roomTypeName} onChange={roomTypeNameChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorTenantName ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Room Type is required!</span>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Daily Price</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={dailyPrice} onChange={dailyPriceChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorGender ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Gender is required!</span>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Weekly Price</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={weeklyPrice} onChange={weeklyPriceChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorGender ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Weekly Price is required!</span>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Monthly Price</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={monthlyPrice} onChange={monthlyPriceChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorIdNumber ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Check In Date is required!</span>
                    </div>
                </div>

                <div>
                    <div className="flex">
                        <div className="flex flex-col sm:flex-row sm:items-center w-full">
                            <div className="w-48">
                                <span>Yearly Price</span>
                            </div>
                            <div className="px-4 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="w-full sm:w-72">
                                <input className="input" value={yearlyPrice} onChange={yearlyPriceChange} />
                            </div>
                        </div>
                    </div>
                    <div className={`flex items-center ${ errorPlaceOfBirth ? 'block' : 'hidden' }`}>
                        <div className="w-48" />
                        <div className="w-9" />
                        <span className="text-red-500">Check Out Date is required!</span>
                    </div>
                </div>

                <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                    <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                    <BackButton onClick={backBtnClick}  />
                </div>
            </div>
                
            {/* Modal */}
 			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
 			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}